import { chunk } from 'lodash-es';

const ASSIGNMENT_LOOKUP_BATCH_SIZE = 100;

/** Loads the identifiers that are already assigned within one bounded candidate batch. */
export type LoadAssignedIds = (candidateIds: string[]) => Promise<string[]>;

/**
 * Returns candidate identifiers that are not currently assigned.
 *
 * Batching bounds every relational lookup to one Engine result page, so a
 * multi-page picker selection cannot be truncated by the default query limit.
 */
export async function findUnassignedIds(
	candidateIds: string[],
	loadAssignedIds: LoadAssignedIds,
): Promise<string[]> {
	const assignedIds = new Set<string>();

	for (const batch of chunk(candidateIds, ASSIGNMENT_LOOKUP_BATCH_SIZE)) {
		const assignedBatchIds = await loadAssignedIds(batch);

		for (const id of assignedBatchIds) assignedIds.add(id);
	}

	return candidateIds.filter((id) => !assignedIds.has(id));
}
